(function (Drupal, once) {
  Drupal.behaviors.contentCardVideoPlayer = {
    attach(context) {
      once('contentCardVideoPlayer', '.video-player', context).forEach((player) => {
        const playButton = player.querySelector('.video-poster__play');
        const posterWrapper = player.querySelector('.video-poster');
        const video = player.querySelector('video');
        if (!playButton || !posterWrapper || !video) {
          return;
        }
        playButton.addEventListener('click', () => {
          // Hide poster layer
          posterWrapper.style.display = 'none';
          // Show video
          video.style.display = 'block';
        });
      });
    }
  };
})(Drupal, once);
